import { getGenerallyIconElement } from '../../components/parts/Button/GenerallyIcons';
import { ContentsItem } from '../../services/staticContents';
import './QAItemComponent.css';

interface qaItemComponentProps {
  qaItem: ContentsItem;
}

export const QAItemComponent = (props: qaItemComponentProps) => {
  const { qaItem } = props;
  return (
    <div className="QAitem" key={qaItem.id}>
      <details className="contents">
        <summary>
          <div className="summary-area">
            <div className="icon-area">{getGenerallyIconElement('help')}</div>
            <p className="title">{qaItem.title}</p>
          </div>
          <div className="icon-summary">{getGenerallyIconElement('next')}</div>
        </summary>
        <div className="answer">{qaItem.answer}</div>
        {qaItem.htmlId && (
          <span className="more-detail">
            詳しくは
            <a href={`/help/${qaItem.htmlId}`} target="_blank" rel="noreferrer">
              こちら
            </a>
          </span>
        )}
      </details>
      <hr />
    </div>
  );
};
